import "./helpers/honeybadger_setup";

import "@hotwired/turbo-rails";
import "invokers-polyfill";

Turbo.session.drive = false;

import "./controllers/application/index";
import "./channels";
